import { supabase } from "@/integrations/supabase/client";

export async function updateChatMessage({
  messageId,
  newMessage,
}: {
  messageId: string;
  newMessage: string;
}) {
  const { data, error } = await supabase
    .from("chat_messages")
    .update({ message: newMessage })
    .eq("id", messageId)
    .select("*")
    .single();

  if (error) throw error;

  return data;
}
